import styled from "styled-components";

const InfoStyle = styled.input`
  appearance: none;
	border: none;
	font-weight: bold;
	font-size: 16px;
  width: 100%;
	&::placeholder{
		color: rgb(200,200,200);
	}
	&:focus {
		outline: none;
	}
`;

export default InfoStyle;